var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnreadNotificationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Make Read & Unread",
    clipPath: "url(#clip0_8667_2531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.24424C0 1.00478 1.00926 0 2.25424 0H11.7458C12.9907 0 14 1.00478 14 2.24424V7H12.6554V2.24424C12.6554 1.74411 12.2481 1.33867 11.7458 1.33867H2.25424C1.75188 1.33867 1.34463 1.74411 1.34463 2.24424V10.9622L3.17966 9.29193H8.52919V10.6306H3.7017L0 14V2.24424Z",
    fill: "var(--secondary-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.5C14 11.5739 13.1294 12.4444 12.0556 12.4444C10.9817 12.4444 10.1111 11.5739 10.1111 10.5C10.1111 9.42611 10.9817 8.55556 12.0556 8.55556C13.1294 8.55556 14 9.42611 14 10.5Z",
    fill: "var(--secondary-4)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8667_2531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "var(--white)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadNotificationOutlined);
export default __webpack_public_path__ + "static/media/unreadNotificationOutlined.9f74bd24ca3979e0b3fb219e9b3cf364.svg";
export { ForwardRef as ReactComponent };